import styled from 'styled-components';

export const Label = styled.p`
  font-size: 14px;
  color: #999;
`;
